import { render } from "./Slider.vue?vue&type=template&id=21fb9e48&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=21fb9e48&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/puchtrade-project/puchtrade/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fb9e48"]])

export default __exports__